    <!-- HEADER -->
    <div style="float:left;">
        <h2 mat-dialog-title><span translate>{{reportTitleInSystem}}</span></h2>
    </div>

    <!-- CONTENT -->
    <mat-dialog-content>

        <!-- <tyl-form-field label="View">
            <mat-select id="Terms" name="Terms" [(ngModel)]="reportParameter.TermId" (selectionchange)="termChanged()">
                <mat-option *ngFor="let result of reportParameter.Terms|orderBy: 'LongDescription'" [value]="result.Id">
                    {{result.LongDescription}}
                </mat-option>
            </mat-select>
        </tyl-form-field> -->

        <table style="width:800px;">

            <!-- <tr>
                <td>
                    <table style="border: 1px solid lightgray;margin-top:10px;"> -->
            <!-- <tr>
                            <td style="padding-left:3px;">
                                <div style="padding-top:5px;">

                                    <tyl-form-field label="View">
                                        <mat-select id="Terms" name="Terms" [(ngModel)]="reportParameter.TermId"
                                            (ngModelChange)="selectionChanged()">
                                            <mat-option
                                                *ngFor="let result of reportParameter.Terms | orderBy: 'LongDescription'"
                                                [value]="result.Id">
                                                {{result.LongDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                </div>
                            </td>
                            <td style="padding-left:3px;">
                                <div style="padding-top:5px;">
                                    <tyl-form-field label="From Period" style="min-width:100px; max-width:100px">
                                        <input matInput #FromPeriod id="FromPeriod" name="FromPeriod"
                                            [(ngModel)]="reportParameter.FromPeriod" min='0' [textMask]="numberMask"
                                            style="text-align:right;width:100px;" (change)="selectionChanged()" />
                                    </tyl-form-field>
                                </div>
                            </td>
                            <td style="padding-left:15px;">
                                <div style="padding-top:5px;">
                                    <tyl-form-field label="To Period" style="min-width:100px; max-width:100px">
                                        <input matInput #ToPeriod id="ToPeriod" name="ToPeriod"
                                            [(ngModel)]="reportParameter.ToPeriod" min='0' [textMask]="numberMask"
                                            style="text-align:right; width:100px;" (change)="selectionChanged()" />
                                    </tyl-form-field>
                                </div>
                            </td>
                            <td style="padding-left:10px;padding-right:3px;">
                                <button mat-button (click)="refreshGrid()">
                                    Update Display
                                </button>
                            </td>
                        </tr> -->
            <tr>
                <td>
                    <tyl-form-field label="Report Title" style="width:350px;">
                        <input matInput name="ReportTitle" id="ReportTitle" #ReportTitle
                            [(ngModel)]="reportParameter.ReportTitle" />
                    </tyl-form-field>
                </td>
            </tr>
            <tr>
                <td>
                    <tyl-form-field label="Term">
                            <mat-select id="Terms" name="Terms" [(ngModel)]="reportParameter.TermId">
                                <mat-option
                                    *ngFor="let result of reportParameter.Terms|orderBy: 'LongDescription'"
                                    [value]="result.Id"
                                    (click) = "termChanged()">
                                    {{result.LongDescription}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                </td>
            </tr>

            <tr>
                <td *ngIf="showDepartment" style="padding-left:3px;">
                    <div style="padding-top:5px;">

                        <tyl-form-field label="Department">
                            <mat-select id="Department" name="Department" [(ngModel)]="selectedDepartment">
                                <mat-option *ngFor="let department of departments | orderBy: 'TextField'"
                                    [value]="department.ValueField"
                                    (click)="selectDepartment(department)">
                                    {{department.TextField}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </div>
                </td>

            </tr>
            <tr>
                <td style="padding-left:3px;">
                    <div style="padding-top:5px;">

                        <tyl-form-field label="Subject">
                            <mat-select id="Courses" name="Courses" [(ngModel)]="selectedCourse">
                                <mat-option *ngFor="let course of filteredCourses | orderBy: 'TextField'"
                                    [value]="course.ValueField">
                                    {{course.TextField}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </div>
                </td>
            </tr>
            <tr>
                <td style="width:150px;padding-top:5px;">
                    <!-- <input name="teacher" type="text" [(ngModel)]="teacher" style="width:350px;" disabled /> -->
                    <tyl-form-field label="Teacher">
                            <mat-select id="Teachers" name="Teachers" [(ngModel)]="selectedTeacher">
                                <mat-option *ngFor="let teacher of teachers | orderBy: 'TextField'"
                                    [value]="teacher.ValueField"
                                    (click)="selectTeacher(teacher)" >
                                    {{teacher.TextField}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                </td>
                <!-- <td style="padding-top:5px;padding-left:3px;"><button (click)="selectTeacher()" >Select</button></td>
                <td style="padding-top:5px;padding-left:3px;"><button (click)="clearTeacher()" >Clear</button></td> -->
            </tr>
            <tr *ngIf="!userIsTeacher">
                <td colspan="4"><span style="color:red;font-style:italic;">Note: Set Teacher field to All to allow selecting Department</span></td>
            </tr>
        </table>
        <!-- </td>
            </tr>
        </table> -->

        <!-- Angular Material table definition -->
        <!-- <div *ngIf="!this.showRun" style="display: flex;flex-direction: column;"
            [ngStyle]="{'overflow': isDataExist ? 'auto' :'hidden' }">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" style="width:100%;">
                <ng-container matColumnDef="selectAllCourses">
                    <th mat-header-cell *matHeaderCellDef>
                        <tyl-checkbox [(checked)]="reportParameter.selectAllReportGridData" id="chkselectAll"
                            name="chkselectAll" (change)="selectAllGridItems(reportParameter.selectAllReportGridData)">
                        </tyl-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <tyl-checkbox [(checked)]="element.Select" #Select (change)="selectClass()" translate>
                        </tyl-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Period">
                    <th mat-header-cell *matHeaderCellDef> Per </th>
                    <td mat-cell *matCellDef="let element">{{element.Period}}</td>
                </ng-container>
                <ng-container matColumnDef="TermCode">
                    <th mat-header-cell *matHeaderCellDef> Term </th>
                    <td mat-cell *matCellDef="let element">{{element.TermCode}}</td>
                </ng-container>
                <ng-container matColumnDef="SubjectCode">
                    <th mat-header-cell *matHeaderCellDef> Subject </th>
                    <td mat-cell *matCellDef="let element">{{element.SubjectCode}}</td>
                </ng-container>
                <ng-container matColumnDef="Section">
                    <th mat-header-cell *matHeaderCellDef>Sec</th>
                    <td mat-cell *matCellDef="let element">{{element.Section}}</td>
                </ng-container>
                <ng-container matColumnDef="AbbreviatedTitle">
                    <th mat-header-cell *matHeaderCellDef> Title </th>
                    <td mat-cell *matCellDef="let element">{{element.AbbreviatedTitle}}</td>
                </ng-container>
                <ng-container matColumnDef="TeacherName">
                    <th mat-header-cell *matHeaderCellDef> Teacher Name</th>
                    <td mat-cell *matCellDef="let element">{{element.TeacherName}}</td>
                </ng-container>
                <ng-container matColumnDef="StudentCount">
                    <th mat-header-cell *matHeaderCellDef> #Std</th>
                    <td mat-cell *matCellDef="let element">{{element.StudentCount}}</td>
                </ng-container>
                <ng-container matColumnDef="DaysGroupDescription">
                    <th mat-header-cell *matHeaderCellDef> Days</th>
                    <td mat-cell *matCellDef="let element">{{element.DaysGroupDescription}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="gridColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: gridColumns;"></tr>
            </table>
        </div> -->




    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions>
        <div class="flex-footer-left" style="align-items: center; width: 30%">
        </div>
        <div class="flex-footer-right" style="align-items: center; width: 70%">
            <error-prompt [errorList]="errors"></error-prompt>
            <tyl-button *ngIf="showRunButton" style="float:right; color: black;" image="save.png" label="Run"
                (clickEvent)="runReportClick()">
            </tyl-button>
            <tyl-button style="float:right; color: black;" image="cancel.png" label="Cancel" (clickEvent)="closeClick()">
            </tyl-button>
        </div>
    </mat-dialog-actions>
